import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Navbar from './components/navbar.jsx';
import ContactInfo from './components/contactinfo.jsx';
// Example pages
import Home from './pages/home.jsx';
import About from './pages/about.jsx';
import Equipment from './pages/equipment.jsx';
import ContactUs from './pages/contact-us.jsx';
function App() {
  return (
    <Router>
    <div className="App">
      <Navbar />
       {/* Main content area */}
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
        </main>
      <ContactInfo />
    </div>
    </Router>
  );
}

export default App;
